<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                @click="
                  printAllAccountReceivableAdvancedTypeReport(
                    'accountReceivableAdvancedTypeReport'
                  )
                "
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="accountReceivableStatusList"
                label="Choose Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="accountReceivableAdvancedTypeList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.customer.code }}</td>
              <td>{{ props.item.customer.name }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.clearStatus }}</td>
              <td>{{ props.item.currency }}</td>
              <td style="text-align: right">
                {{ props.item.advancedAmount | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.cashAmount | decFormat(6) }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds | format-ms-date
                }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--customer dialog-->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="township"
                label="Township"
                type="text"
                v-model="customerQueryParams.township"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="creditLevelList"
                v-model="customerQueryParams.creditLevelId"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-select
                :items="statusList"
                label="Status"
                v-model="customerQueryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="customerHeader"
                :items="customerList"
                class="elevation-1"
                :loading="showCustomerListLoading"
                :total-items="customerTotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="customerPagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedCustomerList"
                      multiple
                    ></v-checkbox>
                  </td>
                  <td>
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.address }}</td>
                  <td style="text-align: right">
                    {{ props.item.advancedAmount | decFormat(6) }}
                  </td>
                  <td>{{ props.item.creditLevel.name }}</td>
                  <td>
                    <v-icon
                      v-if="props.item.status == 'ACTIVE'"
                      medium
                      color="green"
                      >check_circle</v-icon
                    >
                    <v-icon v-else medium color="red">cancel</v-icon>
                  </td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setCustomer">Ok</v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--print all-->
    <div
      id="accountReceivableAdvancedTypeReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          Account Receivable Advanced Type Report
        </p>
      </div>
      <br />
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ queryParams.fromDate }}] To Date: [{{
            queryParams.toDate
          }}]
        </p>
      </div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">Date</th>
              <th style="border: 1px solid black; text-align: center">
                Customer No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer
              </th>
              <th style="border: 1px solid black; text-align: center">
                Cash Receipt No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Clear Status
              </th>
              <th style="border: 1px solid black; text-align: center">Cur</th>
              <th style="border: 1px solid black; text-align: center">
                Advanced Amt
              </th>
              <th style="border: 1px solid black; text-align: center">
                Receipt Amt
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in allAccountReceivableAdvancedTypeList"
            :key="index"
          >
            <tr>
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customer.code }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.customer.name }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.issueNo }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.clearStatus }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.currency }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.advancedAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.cashAmount | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr style="border: 1px solid black; text-align: right">
            <td style="border: 1px solid black; font-weight: bold" colspan="7">
              Grand Total
            </td>
            <td style="border: 1px solid black; text-align: right">
              {{ totalCashAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { customerService } from "../../services/customer-service";
import { creditLevelService } from "../../services/credit-level-service";
import { accountReceivableService } from "../../services/account-receivable-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "AccountReceivableAdvancedTypeReport",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Account Receivable",
        disabled: true,
      },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      status: "",
      shopId: "",
      customerIds: [],
    },
    customerQueryParams: {
      code: "",
      name: "",
      township: "",
      creditLevelId: "",
      status: "",
    },
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Address", value: "address" },
      { text: "Advanced Amount", value: "advancedAmount" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    headers: [
      { text: "Issue Date", align: "left", value: "issue_date" },
      { text: "Customer Code", value: "c.code" },
      { text: "Customer Name", value: "c.name" },
      { text: "Shop", value: "shop_name" },
      { text: "Issue No", align: "left", value: "issue_no" },
      { text: "Clear Status", value: "clearStatus", sortable: false },
      { text: "Currency", value: "currency" },
      { text: "Advanced Amt", value: "c.advanced_amount" },
      { text: "Received Amt", value: "cash_amount" },
      { text: "Updated By", value: "updated_by" },
      { text: "Updated Date", value: "updated_date" },
    ],

    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    accountReceivableStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    accountReceivableTypeList: [
      { label: "----All----", value: "" },
      { label: "Advanced", value: "ADVANCED" },
      { label: "Credit Receive", value: "CREDIT_RECEIVE" },
      { label: "Discount", value: "DISCOUNT" },
      { label: "Damage", value: "DAMAGE" },
    ],
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "code",
      totalItems: 0,
    },
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "issue_date",
      totalItems: 0,
    },

    rowsPerPageItems: [25, 50, 100],
    customerTotalRows: 0,
    totalRows: 0,
    showCustomerListDialog: false,
    showCustomerListLoading: false,
    showListLoading: false,
    printAllButtonLoading: false,
    decimalFormat: "",
    totalCashAmount: "",
    selectedCustomerList: [],
    creditLevelList: [],
    customerList: [],
    accountReceivableAdvancedTypeList: [],
    allAccountReceivableAdvancedTypeList: [],
    clonequeryParams: new Object(),
    shopList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountReceivableAdvancedTypeList();
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getCustomerList();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    this.customerQueryParams.status = "ACTIVE";
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.customerIds) {
      this.queryParams.customerIds = this.$route.query.customerIds;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCreditLevels();
    this.getShopList();
    this.decimalFormat = commonService.formatdecimal();
    this.onSearch();
  },
  methods: {
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "----All----" });
        })
        .catch((err) => {
          console.error(err);
        });
    },

    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "accountReceivableAdvancedTypeReport",
        query: this.queryParams,
      });
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
      this.getAccountReceivableAdvancedTypeList();
    },
    getAccountReceivableAdvancedTypeList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountReceivableService
        .getAccountReceivableAdvancedTypeReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountReceivableAdvancedTypeList =
              res.data.accountReceivableList;
            this.totalRows = res.data.totalElements;
            this.totalCashAmount = res.data.totalCashAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getCustomerList() {
      this.showCustomerListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.customerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showCustomerListLoading = false;
        });
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.customerPagination.page;
      this.customerQueryParams.size = this.customerPagination.rowsPerPage;
      this.getCustomerList();
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.township = "";
      this.customerQueryParams.creditLevelId = "";
      this.customerQueryParams.status = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];
      this.getCustomerList().then(
        (this.showCustomerListDialog = !this.showProductListDialog)
      );
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then((res) => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
            let findAll = {
              id: "",
              name: "----All----",
            };
            this.creditLevelList.splice(
              0,
              0,
              JSON.parse(JSON.stringify(findAll))
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    printAllAccountReceivableAdvancedTypeReport(divName) {
      this.printAllButtonLoading = true;
      accountReceivableService
        .getAllAccountReceivableAdvancedTypeReport(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allAccountReceivableAdvancedTypeList =
              res.data.accountReceivableList;
            this.totalCashAmount = res.data.totalCashAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width = 500,height = 500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
  },
};
</script>